module.exports = __webpack_public_path__ + "img/wordle.231a0935.svg";